import { render, staticRenderFns } from "./_base-card.vue?vue&type=template&id=a92f28f6&scoped=true"
import script from "./_base-card.vue?vue&type=script&lang=js"
export * from "./_base-card.vue?vue&type=script&lang=js"
import style0 from "./_base-card.vue?vue&type=style&index=0&id=a92f28f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92f28f6",
  null
  
)

export default component.exports